/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export interface PhoneCountry {
    name: string;
    code: string;
    shortCode: number | number[];
    textCode: string;
}

export const filteredSpecificCountryFirst = (textCodes: string[], countryList: PhoneCountry[]): PhoneCountry[] => {
    return countryList.sort((a, b) => {
        let indexA = textCodes.indexOf(a.textCode);
        let indexB = textCodes.indexOf(b.textCode);
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        } else if (indexA !== -1) {
            return -1;
        } else if (indexB !== -1) {
            return 1;
        } else {
            return 0;
        }
    });
};
export const filteredCountryList = (textCodes: string[]) => {
    return countryList.filter(country => textCodes.includes(country.textCode));
};
export const countryList: PhoneCountry[] = [
    {name: "Afghanistan", code: "+93", shortCode: 93, textCode: "AF"},
    {name: "Albania", code: "+355", shortCode: 355, textCode: "AL"},
    {name: "Algeria", code: "+213", shortCode: 213, textCode: "DZ"},
    {name: "Andorra", code: "+376", shortCode: 376, textCode: "AD"},
    {name: "Angola", code: "+244", shortCode: 244, textCode: "AO"},
    {name: "Argentina", code: "+54", shortCode: 54, textCode: "AR"},
    {name: "Armenia", code: "+374", shortCode: 374, textCode: "AM"},
    {name: "Australia", code: "+61", shortCode: 61, textCode: "AU"},
    {name: "Austria", code: "+43", shortCode: 43, textCode: "AT"},
    {name: "Azerbaijan", code: "+994", shortCode: 994, textCode: "AZ"},
    {name: "Bahrain", code: "+973", shortCode: 973, textCode: "BH"},
    {name: "Bangladesh", code: "+880", shortCode: 880, textCode: "BD"},
    {name: "Belarus", code: "+375", shortCode: 375, textCode: "BY"},
    {name: "Belgium", code: "+32", shortCode: 32, textCode: "BE"},
    {name: "Belize", code: "+501", shortCode: 501, textCode: "BZ"},
    {name: "Benin", code: "+229", shortCode: 229, textCode: "BJ"},
    {name: "Bhutan", code: "+975", shortCode: 975, textCode: "BT"},
    {name: "Bolivia", code: "+591", shortCode: 591, textCode: "BO"},
    {name: "Bosnia and Herzegovina", code: "+387", shortCode: 387, textCode: "BA"},
    {name: "Botswana", code: "+267", shortCode: 267, textCode: "BW"},
    {name: "Brazil", code: "+55", shortCode: 55, textCode: "BR"},
    {name: "Brunei", code: "+673", shortCode: 673, textCode: "BN"},
    {name: "Bulgaria", code: "+359", shortCode: 359, textCode: "BG"},
    {name: "Burkina Faso", code: "+226", shortCode: 226, textCode: "BF"},
    {name: "Burundi", code: "+257", shortCode: 257, textCode: "BI"},
    {name: "Cambodia", code: "+855", shortCode: 855, textCode: "KH"},
    {name: "Cameroon", code: "+237", shortCode: 237, textCode: "CM"},
    {name: "Canada", code: "+1", shortCode: 1, textCode: "CA"},
    {name: "Cape Verde", code: "+238", shortCode: 238, textCode: "CV"},
    {name: "Central African Republic", code: "+236", shortCode: 236, textCode: "CF"},
    {name: "Chad", code: "+235", shortCode: 235, textCode: "TD"},
    {name: "Chile", code: "+56", shortCode: 56, textCode: "CL"},
    {name: "China", code: "+86", shortCode: 86, textCode: "CN"},
    {name: "Colombia", code: "+57", shortCode: 57, textCode: "CO"},
    {name: "Comoros", code: "+269", shortCode: 269, textCode: "KM"},
    {name: "Costa Rica", code: "+506", shortCode: 506, textCode: "CR"},
    {name: "Croatia", code: "+385", shortCode: 385, textCode: "HR"},
    {name: "Cuba", code: "+53", shortCode: 53, textCode: "CU"},
    {name: "Cyprus", code: "+357", shortCode: 357, textCode: "CY"},
    {name: "Czech Republic", code: "+420", shortCode: 420, textCode: "CZ"},
    {name: "Denmark", code: "+45", shortCode: 45, textCode: "DK"},
    {name: "Djibouti", code: "+253", shortCode: 253, textCode: "DJ"},
    {name: "Dominican Republic", code: "+1 809, +1 829, +1 849", shortCode: [809, 829, 849], textCode: "DO"},
    {name: "Ecuador", code: "+593", shortCode: 593, textCode: "EC"},
    {name: "Egypt", code: "+20", shortCode: 20, textCode: "EG"},
    {name: "El Salvador", code: "+503", shortCode: 503, textCode: "SV"},
    {name: "Equatorial Guinea", code: "+240", shortCode: 240, textCode: "GQ"},
    {name: "Eritrea", code: "+291", shortCode: 291, textCode: "ER"},
    {name: "Estonia", code: "+372", shortCode: 372, textCode: "EE"},
    {name: "Ethiopia", code: "+251", shortCode: 251, textCode: "ET"},
    {name: "Fiji", code: "+679", shortCode: 679, textCode: "FJ"},
    {name: "Finland", code: "+358", shortCode: 358, textCode: "FI"},
    {name: "France", code: "+33", shortCode: 33, textCode: "FR"},
    {name: "Gabon", code: "+241", shortCode: 241, textCode: "GA"},
    {name: "Gambia", code: "+220", shortCode: 220, textCode: "GM"},
    {name: "Georgia", code: "+995", shortCode: 995, textCode: "GE"},
    {name: "Germany", code: "+49", shortCode: 49, textCode: "DE"},
    {name: "Ghana", code: "+233", shortCode: 233, textCode: "GH"},
    {name: "Greece", code: "+30", shortCode: 30, textCode: "GR"},
    {name: "Guatemala", code: "+502", shortCode: 502, textCode: "GT"},
    {name: "Guinea", code: "+224", shortCode: 224, textCode: "GN"},
    {name: "Guinea-Bissau", code: "+245", shortCode: 245, textCode: "GW"},
    {name: "Guyana", code: "+592", shortCode: 592, textCode: "GY"},
    {name: "Haiti", code: "+509", shortCode: 509, textCode: "HT"},
    {name: "Honduras", code: "+504", shortCode: 504, textCode: "HN"},
    {name: "Hungary", code: "+36", shortCode: 36, textCode: "HU"},
    {name: "Iceland", code: "+354", shortCode: 354, textCode: "IS"},
    {name: "India", code: "+91", shortCode: 91, textCode: "IN"},
    {name: "Indonesia", code: "+62", shortCode: 62, textCode: "ID"},
    {name: "Iran", code: "+98", shortCode: 98, textCode: "IR"},
    {name: "Iraq", code: "+964", shortCode: 964, textCode: "IQ"},
    {name: "Ireland", code: "+353", shortCode: 353, textCode: "IE"},
    {name: "Israel", code: "+972", shortCode: 972, textCode: "IL"},
    {name: "Italy", code: "+39", shortCode: 39, textCode: "IT"},
    {name: "Jamaica", code: "+1 876", shortCode: 876, textCode: "JM"},
    {name: "Japan", code: "+81", shortCode: 81, textCode: "JP"},
    {name: "Jordan", code: "+962", shortCode: 962, textCode: "JO"},
    {name: "Kazakhstan", code: "+7", shortCode: 7, textCode: "KZ"},
    {name: "Kenya", code: "+254", shortCode: 254, textCode: "KE"},
    {name: "Kiribati", code: "+686", shortCode: 686, textCode: "KI"},
    {name: "Kuwait", code: "+965", shortCode: 965, textCode: "KW"},
    {name: "Kyrgyzstan", code: "+996", shortCode: 996, textCode: "KG"},
    {name: "Laos", code: "+856", shortCode: 856, textCode: "LA"},
    {name: "Latvia", code: "+371", shortCode: 371, textCode: "LV"},
    {name: "Lebanon", code: "+961", shortCode: 961, textCode: "LB"},
    {name: "Lesotho", code: "+266", shortCode: 266, textCode: "LS"},
    {name: "Liberia", code: "+231", shortCode: 231, textCode: "LR"},
    {name: "Libya", code: "+218", shortCode: 218, textCode: "LY"},
    {name: "Liechtenstein", code: "+423", shortCode: 423, textCode: "LI"},
    {name: "Lithuania", code: "+370", shortCode: 370, textCode: "LT"},
    {name: "Luxembourg", code: "+352", shortCode: 352, textCode: "LU"},
    {name: "Macedonia", code: "+389", shortCode: 389, textCode: "MK"},
    {name: "Madagascar", code: "+261", shortCode: 261, textCode: "MG"},
    {name: "Malawi", code: "+265", shortCode: 265, textCode: "MW"},
    {name: "Malaysia", code: "+60", shortCode: 60, textCode: "MY"},
    {name: "Maldives", code: "+960", shortCode: 960, textCode: "MV"},
    {name: "Mali", code: "+223", shortCode: 223, textCode: "ML"},
    {name: "Malta", code: "+356", shortCode: 356, textCode: "MT"},
    {name: "Marshall Islands", code: "+692", shortCode: 692, textCode: "MH"},
    {name: "Mauritania", code: "+222", shortCode: 222, textCode: "MR"},
    {name: "Mauritius", code: "+230", shortCode: 230, textCode: "MU"},
    {name: "Mexico", code: "+52", shortCode: 52, textCode: "MX"},
    {name: "Micronesia", code: "+691", shortCode: 691, textCode: "FM"},
    {name: "Moldova", code: "+373", shortCode: 373, textCode: "MD"},
    {name: "Monaco", code: "+377", shortCode: 377, textCode: "MC"},
    {name: "Mongolia", code: "+976", shortCode: 976, textCode: "MN"},
    {name: "Montenegro", code: "+382", shortCode: 382, textCode: "ME"},
    {name: "Morocco", code: "+212", shortCode: 212, textCode: "MA"},
    {name: "Mozambique", code: "+258", shortCode: 258, textCode: "MZ"},
    {name: "Myanmar", code: "+95", shortCode: 95, textCode: "MM"},
    {name: "Namibia", code: "+264", shortCode: 264, textCode: "NA"},
    {name: "Nauru", code: "+674", shortCode: 674, textCode: "NR"},
    {name: "Nepal", code: "+977", shortCode: 977, textCode: "NP"},
    {name: "Netherlands", code: "+31", shortCode: 31, textCode: "NL"},
    {name: "New Zealand", code: "+64", shortCode: 64, textCode: "NZ"},
    {name: "Nicaragua", code: "+505", shortCode: 505, textCode: "NI"},
    {name: "Niger", code: "+227", shortCode: 227, textCode: "NE"},
    {name: "Nigeria", code: "+234", shortCode: 234, textCode: "NG"},
    {name: "North Korea", code: "+850", shortCode: 850, textCode: "KP"},
    {name: "Norway", code: "+47", shortCode: 47, textCode: "NO"},
    {name: "Oman", code: "+968", shortCode: 968, textCode: "OM"},
    {name: "Pakistan", code: "+92", shortCode: 92, textCode: "PK"},
    {name: "Palau", code: "+680", shortCode: 680, textCode: "PW"},
    {name: "Palestine", code: "+970", shortCode: 970, textCode: "PS"},
    {name: "Panama", code: "+507", shortCode: 507, textCode: "PA"},
    {name: "Papua New Guinea", code: "+675", shortCode: 675, textCode: "PG"},
    {name: "Paraguay", code: "+595", shortCode: 595, textCode: "PY"},
    {name: "Peru", code: "+51", shortCode: 51, textCode: "PE"},
    {name: "Philippines", code: "+63", shortCode: 63, textCode: "PH"},
    {name: "Poland", code: "+48", shortCode: 48, textCode: "PL"},
    {name: "Portugal", code: "+351", shortCode: 351, textCode: "PT"},
    {name: "Qatar", code: "+974", shortCode: 974, textCode: "QA"},
    {name: "Republic of the Congo", code: "+242", shortCode: 242, textCode: "CG"},
    {name: "Romania", code: "+40", shortCode: 40, textCode: "RO"},
    {name: "Russia", code: "+7", shortCode: 7, textCode: "RU"},
    {name: "Rwanda", code: "+250", shortCode: 250, textCode: "RW"},
    {name: "Saint Kitts and Nevis", code: "+1 869", shortCode: 869, textCode: "KN"},
    {name: "Saint Lucia", code: "+1 758", shortCode: 758, textCode: "LC"},
    {name: "Saint Vincent and the Grenadines", code: "+1 784", shortCode: 784, textCode: "VC"},
    {name: "Samoa", code: "+685", shortCode: 685, textCode: "WS"},
    {name: "San Marino", code: "+378", shortCode: 378, textCode: "SM"},
    {name: "Sao Tome and Principe", code: "+239", shortCode: 239, textCode: "ST"},
    {name: "Saudi Arabia", code: "+966", shortCode: 966, textCode: "SA"},
    {name: "Senegal", code: "+221", shortCode: 221, textCode: "SN"},
    {name: "Serbia", code: "+381", shortCode: 381, textCode: "RS"},
    {name: "Seychelles", code: "+248", shortCode: 248, textCode: "SC"},
    {name: "Sierra Leone", code: "+232", shortCode: 232, textCode: "SL"},
    {name: "Singapore", code: "+65", shortCode: 65, textCode: "SG"},
    {name: "Slovakia", code: "+421", shortCode: 421, textCode: "SK"},
    {name: "Slovenia", code: "+386", shortCode: 386, textCode: "SI"},
    {name: "Solomon Islands", code: "+677", shortCode: 677, textCode: "SB"},
    {name: "Somalia", code: "+252", shortCode: 252, textCode: "SO"},
    {name: "South Africa", code: "+27", shortCode: 27, textCode: "ZA"},
    {name: "South Korea", code: "+82", shortCode: 82, textCode: "KR"},
    {name: "South Sudan", code: "+211", shortCode: 211, textCode: "SS"},
    {name: "Spain", code: "+34", shortCode: 34, textCode: "ES"},
    {name: "Sri Lanka", code: "+94", shortCode: 94, textCode: "LK"},
    {name: "Sudan", code: "+249", shortCode: 249, textCode: "SD"},
    {name: "Suriname", code: "+597", shortCode: 597, textCode: "SR"},
    {name: "Swaziland", code: "+268", shortCode: 268, textCode: "SZ"},
    {name: "Sweden", code: "+46", shortCode: 46, textCode: "SE"},
    {name: "Schweiz", code: "+41", shortCode: 41, textCode: "CH"},
    {name: "Syria", code: "+963", shortCode: 963, textCode: "SY"},
    {name: "Taiwan", code: "+886", shortCode: 886, textCode: "TW"},
    {name: "Tajikistan", code: "+992", shortCode: 992, textCode: "TJ"},
    {name: "Tanzania", code: "+255", shortCode: 255, textCode: "TZ"},
    {name: "Thailand", code: "+66", shortCode: 66, textCode: "TH"},
    {name: "Timor-Leste", code: "+670", shortCode: 670, textCode: "TL"},
    {name: "Togo", code: "+228", shortCode: 228, textCode: "TG"},
    {name: "Tonga", code: "+676", shortCode: 676, textCode: "TO"},
    {name: "Trinidad and Tobago", code: "+1 868", shortCode: 868, textCode: "TT"},
    {name: "Tunisia", code: "+216", shortCode: 216, textCode: "TN"},
    {name: "Turkey", code: "+90", shortCode: 90, textCode: "TR"},
    {name: "Turkmenistan", code: "+993", shortCode: 993, textCode: "TM"},
    {name: "Tuvalu", code: "+688", shortCode: 688, textCode: "TV"},
    {name: "Uganda", code: "+256", shortCode: 256, textCode: "UG"},
    {name: "Ukraine", code: "+380", shortCode: 380, textCode: "UA"},
    {name: "United Arab Emirates", code: "+971", shortCode: 971, textCode: "AE"},
    {name: "United Kingdom", code: "+44", shortCode: 44, textCode: "GB"},
    {name: "United States and Canada", code: "+1", shortCode: 1, textCode: "US"},
    {name: "Uruguay", code: "+598", shortCode: 598, textCode: "UY"},
    {name: "Uzbekistan", code: "+998", shortCode: 998, textCode: "UZ"},
    {name: "Vanuatu", code: "+678", shortCode: 678, textCode: "VU"},
    {name: "Vatican City", code: "+39", shortCode: 39, textCode: "VA"},
    {name: "Venezuela", code: "+58", shortCode: 58, textCode: "VE"},
    {name: "Vietnam", code: "+84", shortCode: 84, textCode: "VN"},
    {name: "Yemen", code: "+967", shortCode: 967, textCode: "YE"},
    {name: "Zambia", code: "+260", shortCode: 260, textCode: "ZM"},
    {name: "Zimbabwe", code: "+263", shortCode: 263, textCode: "ZW"},
];
